export const getGuideLineDate = ({
  position,
  tickStartDate,
  tickFinishDate,
  width,
  originalWidth,
}: {
  position: number
  tickStartDate?: Date
  tickFinishDate?: Date
  width: number
  originalWidth: number
}) => {
  const startDate = tickStartDate as Date
  const finishDate = tickFinishDate as Date

  const time =
    (position / Math.max(width, originalWidth)) * (finishDate.getTime() - startDate.getTime()) +
    startDate.getTime()

  return new Date(time)
}

export const getGuideLinePosition = ({
  date,
  tickStartDate,
  tickFinishDate,
  width,
  originalWidth,
}: {
  date: Date
  tickStartDate?: Date
  tickFinishDate?: Date
  width: number
  originalWidth: number
}) => {
  const startDate = tickStartDate as Date
  const finishDate = tickFinishDate as Date

  const timeDiff = date.getTime() - startDate.getTime()
  const totalDiff = finishDate.getTime() - startDate.getTime()

  return (timeDiff / totalDiff) * Math.max(width, originalWidth)
}
